import { Injectable } from '@angular/core';
import { randText } from '@ngneat/falso';
import { Set } from 'immutable';

import { ElementPermission } from '../../../core/domain/permission-types';
import { PermissionConfigItemEntity } from '../../../ui/components/app-permissions-configurator/permission-config-item.entity';
import { PermissionConfigListEntity } from '../../../ui/components/app-permissions-configurator/permission-config-list.entity';

@Injectable()
export class PermissionConfigListProvider {
	private readonly permissionConfigList: PermissionConfigListEntity;

	public constructor() {
		this.permissionConfigList = PermissionConfigListEntity.build([
			{
				permission: ElementPermission.View,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: ElementPermission.Edit,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: ElementPermission.Delete,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: ElementPermission.Export,
				toggled: false,
				isDisabled: true,
			},
			{
				permission: ElementPermission.Share,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: ElementPermission.Persist,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: ElementPermission.Link,
				toggled: false,
				isDisabled: true,
			},
			{
				permission: ElementPermission.Permissions,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: ElementPermission.Data_catalog,
				toggled: false,
				isDisabled: false,
			},
		]);
	}

	public getList(): PermissionConfigListEntity {
		return this.permissionConfigList;
	}

	public setAutoElements(): PermissionConfigListEntity {
		const elements: Array<PermissionConfigItemEntity> = this.generateData();

		const elems = new Map(elements.map((item) => [`${item.id}`, item]));
		return this.permissionConfigList.setElements(elems);
	}

	private generateData(count = 5): Array<PermissionConfigItemEntity> {
		return Array.from({
			length: count,
		}).map((_, index) =>
			PermissionConfigItemEntity.build({
				id: `${index + 1}`,
				element: randText({
					charCount: 100,
				}),
				permissions: Set([ElementPermission.View, ElementPermission.Edit]),
			})
		);
	}
}
